import {
  bankIntegrationDataSources,
  IDocument,
  ImportDataSource,
  IImportData
} from '@query/documents'

export const isAccrualInvoiceImportSource = (source?: ImportDataSource): boolean =>
  source === ImportDataSource.SALES_INVOICE || source === ImportDataSource.PURCHASE_INVOICE

export const parseImportInvoiceId = (identifier?: string | null): number | null => {
  if (!identifier) {
    return null
  }
  const id = Number.parseInt(identifier, 10)
  if (!Number.isFinite(id) || id <= 0) {
    return null
  }
  return id
}

export const showsImportSourceTab = (importData?: IImportData | null): boolean =>
  Boolean(importData && bankIntegrationDataSources.includes(importData.data_source))

export const canShowSourceInvoiceWidget = (
  document: Pick<IDocument, 'import_data'>,
  hasInvoicingView: boolean
): boolean => {
  const importData = document.import_data
  if (!importData || !hasInvoicingView) {
    return false
  }
  if (!isAccrualInvoiceImportSource(importData.data_source)) {
    return false
  }
  return parseImportInvoiceId(importData.identifier) != null
}
